/**
 * Make all child elements matching height according to which is the biggest
*/

import EventBus from '../event-bus.js'
import jQuery from 'jquery'

const SyncChildHeights = {
    
    /**
     * Run module
    */
    run() {
        this.bindEvents()
        SyncChildHeights.syncHeights()
    },
    
    /**
     * Synchronise child heights of all selectable parents
    */
    syncHeights() {
        jQuery('.sync-child-heights').each(
            (i, element) => {
                SyncChildHeights.syncHeight(jQuery(element))
            }
        )
    },
    
    /**
     * Synchronise child heights of specific parent
     * @param parent
    */
    syncHeight(parent) {
        
        var
            target,
            maxHeight = 0,
            minSyncWidth = parent.data('min-sync-width'),
            display,
            targets = parent.data('targets'),
            startsHidden = false
        
        if (!targets) {
            targets = '> *'
        }
        
        //Show the parent if it starts hidden so child height can be calculated
        if (parent.data('starts-hidden') && parent.css('display') == 'none') {
            startsHidden = true
            parent.show()
        }
        else {
            startsHidden = false
        }
        
        //Trigger start event on parent
        parent.trigger('height-sync-start')
        
        jQuery.each(targets.split(','), (index, value) => {
            
            //Reset heights if screen size is below specified breakpoint
            if (minSyncWidth && !window.matchMedia('(min-width: ' + minSyncWidth + 'px)').matches) {
                parent.find(value).height('')
                return
            }
            
            maxHeight = 0
            
            parent.find(value).each(
                (ci, element) => {
                    target = jQuery(element)
                    display = element.style.display
                    target.height('').css('display', 'block')
                    maxHeight = Math.max(maxHeight, target.height())
                    element.style.display = display
                }
            ).height(maxHeight)
            
        })
        
        //Re-hide parent if it starts hidden
        if (startsHidden) {
            parent.hide()
        }
        
        //Trigger end event on parent
        parent.trigger('height-sync-end')
        
    },
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Subscribe to resizing of individual parents
        EventBus.subscribe('sync-child-heights', SyncChildHeights.syncHeight)
        
        //Synchronise heights on window resize
        jQuery(window).resize(SyncChildHeights.syncHeights)
        
    }

}

EventBus.subscribe('run-modules', SyncChildHeights.run.bind(SyncChildHeights))

export default SyncChildHeights